<!--sidebar-->
<c-sidebar #sidebar1="cSidebar" class="d-print-none sidebar sidebar-fixed border-end" colorScheme="dark" id="sidebar1"
  visible>
  <c-sidebar-header>
    <c-sidebar-brand cSidebarToggle="sidebar1" toggle="unfoldable" style="cursor: pointer; display: flex;">
      <img src="assets/images/app/manosya/manosya-logo-white.svg" alt="Logo ManosYa" class="sidebar-brand-full mb-4"
        style="object-fit: contain; max-width: 108px;">
      <img src="assets/images/app/manosya/manosya-logo-white.svg" alt="Logo ManosYa" class="sidebar-brand-narrow mb-4"
        style="object-fit: contain; max-width: 32px;">
    </c-sidebar-brand>
  </c-sidebar-header>

  <ng-scrollbar #scrollbar="ngScrollbar" (updated)="onScrollbarUpdate(scrollbar.state)" class="overflow"
    pointerEventsMethod="scrollbar" visibility="hover">
    <c-sidebar-nav #overflow [navItems]="navItems" dropdownMode="close" compact />
  </ng-scrollbar>
</c-sidebar>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100">
  <!--app-header-->
  <app-default-header [cShadowOnScroll]="'sm'" class="mb-4 d-print-none header header-sticky p-0 shadow-sm"
    position="sticky" sidebarId="sidebar1" (showModalEvent)="onShowModal($event)" />
  <!--app-body-->
  <div class="body flex-grow-1">
    <c-container breakpoint="md" class="h-auto p-4">
      <app-default-breadcrumb />
      <router-outlet />
    </c-container>
  </div>
  <!--app footer-->
  <app-default-footer />
</div>

<!--aside-->
<app-default-aside style="display: none;" />

<c-modal #modal id="logoutModal" backdrop="static" [visible]="showLogoutModal">
  <c-modal-header>
    <h5 class="modal-title d-flex align-items-center text-danger">
      Cerrar sesión
    </h5>
    <button cButtonClose (click)="closeLogoutModal()"></button>
  </c-modal-header>
  <c-modal-body class="pt-2">
    <p class="text-muted mb-0 text-center">
      ¿Estás seguro que deseas continuar?
    </p>
  </c-modal-body>
  <c-modal-footer class="justify-content-center">
    <button cButton color="secondary" class="btn btn-primary px-4" (click)="closeLogoutModal()">
      Cancelar
    </button>
    <button cButton color="danger" class="btn btn-primary px-4" (click)="logout()">
      Cerrar sesión
    </button>
  </c-modal-footer>
</c-modal>